import { render } from "./InputToken.vue?vue&type=template&id=1c787a8c"
import script from "./InputToken.vue?vue&type=script&lang=js"
export * from "./InputToken.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__